import { Component } from "react"
import PropTypes from "prop-types"
import Feedback from "partners/components/review/feedback"
import sortBy from "lodash/sortBy"
import last from "lodash/last"
import { post } from "shared/lib/api"

export default class FeedbackContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      feedbackItems: this.props.feedbackItems,
      isShowing: false,
      displayAll: false,
    }
    this.showFeedbacks = this.showFeedbacks.bind(this)
    this.showAllFeedbacks = this.showAllFeedbacks.bind(this)
    this.closeFeedbacks = this.closeFeedbacks.bind(this)
    this.hideAllFeedbackFormsOnClickOff = this.hideAllFeedbackFormsOnClickOff.bind(this)
    this.postFeedback = this.postFeedback.bind(this)
    this.onFeedbackUpdated = this.props.onFeedbackUpdated
  }

  componentDidMount() {
    this.hideListener = window.addEventListener("hideFeedbackContainers", () => {
      this.setState({ isShowing: false, displayAll: false })
    })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ feedbackItems: nextProps.feedbackItems })
  }

  componentWillUnmount() {
    window.removeEventListener("hideFeedbackContainers", this.hideListener)
  }

  hideAllFeedbackFormsOnClickOff() {
    this.setState({ displayAll: false, isShowing: false })
  }

  showFeedbacks() {
    this.setState({ isShowing: true })
  }

  showAllFeedbacks() {
    this.setState({ displayAll: true, isShowing: true })
  }

  closeFeedbacks() {
    if (!this.state.displayAll) this.setState({ isShowing: false })
  }

  displayLastFeedback() {
    if (!this.state.isShowing || this.state.feedbackItems.length == 0) return null

    const lastItem = last(
      sortBy(this.state.feedbackItems, item => {
        return item.time
      })
    )
    return (
      <div className="feedback-content">
        <Feedback key={`feedback-${lastItem.time}`} values={lastItem} pathObjs={this.props.pathObjs} preview />
      </div>
    )
  }

  displayAll() {
    if (!this.state.isShowing) return null

    const allItems = this.state.feedbackItems.map((item, index) => {
      return (
        <Feedback
          key={`feedback-${item.time}`}
          values={item}
          pathObjs={this.props.pathObjs}
          index={index}
          service={this.props.service}
          onFeedbackUpdated={this.props.onFeedbackUpdated}
        />
      )
    })
    return (
      <div className="feedback-content">
        {allItems}
        {this.newFeedbackForm()}
      </div>
    )
  }

  postFeedback(event) {
    event.preventDefault()

    const _target = event.target.closest("form").querySelector("#comment")
    let _feedback = _target.value
    _feedback = _feedback.replace(/(\r\n|\n|\r)/gm, " ")

    if (/\S/.test(_feedback)) {
      post(`/services/${this.props.service.slug}/feedbacks`, {
        feedback: _feedback,
        feedback_path: this.props.pathObjs,
        authenticity_token: window.App.authenticityToken,
      }).then(response => {
        this.onFeedbackUpdated(response)
        _target.value = ""
      })
    } else {
      window.alert("You should write something first!")
    }
  }

  newFeedbackForm() {
    return (
      <form className="form">
        <div className="field">
          <div className="label">
            Add a note on <strong>{this.props.fieldName}</strong>:
          </div>
          <div className="input">
            <textarea id="comment" name="comment" required="required" rows="3" autoFocus />
          </div>
          <p className="note" />
        </div>
        <div className="action">
          <a className="button-tertiary button-cancel-link" onClick={this.hideAllFeedbackFormsOnClickOff}>
            Close
          </a>
          <button className="button-tertiary" data-disable-with="Saving…" onClick={this.postFeedback}>
            Post
          </button>
        </div>
      </form>
    )
  }

  renderBubble() {
    return (
      <div>
        <span className="feedback-icon" onClick={this.showAllFeedbacks} title="Feedback" />
        <div>{this.state.displayAll ? this.displayAll() : this.displayLastFeedback()}</div>
      </div>
    )
  }

  renderInactive() {
    if (this.state.displayAll) return this.renderBubble()

    return <span className="feedback-icon inactive" onClick={this.showAllFeedbacks} title="Feedback" />
  }

  render() {
    return (
      <div className="feedback-container" onMouseOver={this.showFeedbacks} onMouseOut={this.closeFeedbacks}>
        {this.state.feedbackItems.length > 0 ? this.renderBubble() : this.renderInactive()}
      </div>
    )
  }
}

FeedbackContainer.propTypes = {
  feedbackItems: PropTypes.array,
  fieldName: PropTypes.string,
  service: PropTypes.object,
  pathObjs: PropTypes.array,
  onFeedbackUpdated: PropTypes.func,
}

FeedbackContainer.defaultProps = {
  feedbackItems: [],
}
